// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IProcessorInfo } from './IProcessorInfo';
import {
    IProcessorInfoFromJSON,
    IProcessorInfoFromJSONTyped,
    IProcessorInfoToJSON,
    IProcessorInfoToJSONTyped,
} from './IProcessorInfo';
import type { IResponseMessage } from './IResponseMessage';
import {
    IResponseMessageFromJSON,
    IResponseMessageFromJSONTyped,
    IResponseMessageToJSON,
    IResponseMessageToJSONTyped,
} from './IResponseMessage';

/**
 * 
 * @export
 * @interface IAccountMaintUpdateResult
 */
export interface IAccountMaintUpdateResult {
    /**
     * 
     * @type {IProcessorInfo}
     * @memberof IAccountMaintUpdateResult
     */
    processor_info?: IProcessorInfo;
    /**
     * List of response messages from server.
     * @type {Array<IResponseMessage>}
     * @memberof IAccountMaintUpdateResult
     */
    messages?: Array<IResponseMessage>;
    /**
     * Map of messages to ods responses from server.
     * @type {{ [key: string]: string; }}
     * @memberof IAccountMaintUpdateResult
     */
    message_map?: { [key: string]: string; };
}

/**
 * Check if a given object implements the IAccountMaintUpdateResult interface.
 */
export function instanceOfIAccountMaintUpdateResult(value: object): value is IAccountMaintUpdateResult {
    return true;
}

export function IAccountMaintUpdateResultFromJSON(json: any): IAccountMaintUpdateResult {
    return IAccountMaintUpdateResultFromJSONTyped(json, false);
}

export function IAccountMaintUpdateResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountMaintUpdateResult {
    if (json == null) {
        return json;
    }
    return {
        
        'processor_info': json['processorInfo'] == null ? undefined : IProcessorInfoFromJSON(json['processorInfo']),
        'messages': json['messages'] == null ? undefined : ((json['messages'] as Array<any>).map(IResponseMessageFromJSON)),
        'message_map': json['messageMap'] == null ? undefined : json['messageMap'],
    };
}

export function IAccountMaintUpdateResultToJSON(json: any): IAccountMaintUpdateResult {
    return IAccountMaintUpdateResultToJSONTyped(json, false);
}

export function IAccountMaintUpdateResultToJSONTyped(value?: IAccountMaintUpdateResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'processorInfo': IProcessorInfoToJSON(value['processor_info']),
        'messages': value['messages'] == null ? undefined : ((value['messages'] as Array<any>).map(IResponseMessageToJSON)),
        'messageMap': value['message_map'],
    };
}

